import * as Cookies from 'js-cookie';
import { Failure, GeneralError } from '../ApiClient';
import { ApplicationError } from '../ApplicationError';
import { ErrorLogger } from '../ErrorLogger';

import type { PublicApi } from '../type-helpers';

export default class ErrorHandler implements IErrorHandler {
	public constructor(private readonly logger: ErrorLogger) {}

	public handle<Error, MetaValue>(error: Error, meta?: { [key: string]: MetaValue }): ApplicationError | null {
		if (error instanceof Failure) {
			return this.handleApiFailure(error);
		}

		this.logger.logError(error, { tags: [], meta: meta ?? {} });
		return ApplicationError.generalFailure;
	}

	private handleApiFailure<MetaValue>(
		failure: Failure<string>,
		meta?: { [key: string]: MetaValue }
	): ApplicationError | null {
		if (failure.hasAnyOf(Object.values(GeneralError))) {
			return ApplicationError.connectionFailure;
		}

		if (
			failure.has('missing-access-token') ||
			failure.has('authentication-inactive-security-token') ||
			failure.has('authentication-unknown-security-token') ||
			failure.has('authentication-invalid-security-token-header') ||
			failure.has('authentication-missing-security-token')
		) {
			// tslint:disable:no-unsafe-any
			Cookies.withConverter({
				write(value: string | object, name: string) {
					if (typeof value === 'object') {
						return value.toString();
					}
					return value;
				},
			}).set('login-redirect-url', window.location.pathname + window.location.search + window.location.hash, {
				expires: 1,
				path: '/',
			});
			// tslint:disable:no-any
			window.location = '/login' as any;
		}

		const apiError = new Error(Array.from(failure.codes).join(','));
		apiError.name = 'ApiClientErrorResponse';
		this.logger.logError(apiError, { tags: Array.from(failure.codes), meta: meta ?? {} });
		return ApplicationError.connectionFailure;
	}
}

export type IErrorHandler = PublicApi<ErrorHandler>;
